import { useAuth0 } from "@auth0/auth0-react";
import Typography from "@mui/material/Typography";
import { InputField } from "components";
import { useFormik } from "formik";
import PastoralService from "Lib/API/PastoralApi";
import React, { useMemo, useState } from "react";
import { toastr } from "react-redux-toastr";
import { eventTypeSettings } from "../../../ValidationSchema";
import "./index.scss";

const AddEventType = ({ closeModal,handleClose, data, type, fetchEvents, ...props }) => {
  const { getAccessTokenSilently } = useAuth0();

  const [isLoading, setIsLoading] = useState(false);
  const initialValues = {
    name: data?.name || "",
    description: (data?.description && data?.description !== "undefined") ? data?.description : "",
  };

  const createEventTypeHandler = async (payload) => {
    setIsLoading(true);
    const token = await getAccessTokenSilently();
    PastoralService.createEventType({ data: payload, token})
    .then((response) => {
      toastr.success("Success", "Event Type Created Successfully");
      handleClose();
      fetchEvents();
    })
    .catch((error) => {
      console.log('error :', error);
      toastr.error("Error", error?.data?.message || "Something went wrong");
    })
    .finally(() => {
      setIsLoading(false);
    });
  }

  const updateEventTypeHandler = async (payload) => {
    setIsLoading(true);
    const token = await getAccessTokenSilently();
    PastoralService.updateEventType({ data: payload, eventTypeId:data?.id, token})
    .then((response) => {
      toastr.success("Success", "Event Type Updated Successfully");
      handleClose();
      fetchEvents();
    })
    .catch((error) => {
      console.log('error :', error);
      toastr.error("Error", error?.data?.message || "Something went wrong");
    })
    .finally(() => {
      setIsLoading(false);
    });
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: eventTypeSettings,

    onSubmit: async (values) => {
      const payload = {
        name: values?.name?.trim(),
        description: values?.description?.trim(),
      };
      if (type === "edit") {
        updateEventTypeHandler(payload);
        return;
      }
      createEventTypeHandler(payload);
    },
  });


  const isDisabled = useMemo(() => {
    return !formik.isValid || !formik.dirty || isLoading;
  }, [formik.isValid, formik.dirty, isLoading]);

  return (
    <>
      <div className="add-event-type-page">
      <div className="add-group-header update__user__header mt-5 justify-content-center">
        <Typography variant="h5" gutterBottom>
          New Event Type
        </Typography>
      </div>
        <div className="eventType-form">
          <div className="eventType-form-field">
            <InputField
              {...{
                formik,
                title: "Name",
                name: "name",
                placeholder: "Add Name",
                checkValidation: true,
                value: formik.values?.name,
                mandatory: true,
              }}
            />
          </div>
          <div className="eventType-form-field">
            <InputField
              {...{
                formik,
                title: "Description",
                name: "description",
                placeholder: "Add Description",
                checkValidation: true,
                value: formik.values?.description,
                mandatory: false,
              }}
            />
          </div>
        </div>
        <div className="update__user__header">
        <div className="user__header__action add-event-type-page__actions">
          <button
            className="cancel_user_btn"
            onClick={closeModal}
          >
            Cancel
          </button>
          <button
            className="save_user_btn btn btn-primary"
            onClick={formik.handleSubmit}
            disabled={isDisabled}
          >
            <span className="user_btn_text">Save</span>
            {isLoading && (
              <span className="ml-3 spinner spinner-white"></span>
            )}
          </button>
        </div>
        </div>
      </div>
    </>
  );
};

export default AddEventType;
